// export function formatToNumber(value) {
//   if (value) {
//     const numericValue = value.replace(/\D+/g, '');
//     // Format the numeric value as "111-111-1111"
//     const formattedNumber = numericValue.replace(/^(\d{3})(\d{3})(\d{4})$/, '$1-$2-$3');
//     return formattedNumber;
//   }
//   else {
//     return "";
//   }

// }

export function formatToNumber(value) {
  if (!value) return "";

  // Remove all characters except digits and plus
  let cleaned = value.replace(/[^0-9+]/g, "");

  // If it starts with '+', keep it and remove any other '+' and non-digits
  if (cleaned.startsWith("+")) {
    cleaned = "+" + cleaned.slice(1).replace(/\+/g, "").replace(/\D/g, "").slice(0, 14);
  } else {
    // No plus at the beginning — remove all non-digits and trim to 15
    cleaned = cleaned.replace(/\D/g, "").slice(0, 15);
  }

  return cleaned;
}


export function addZeroes(num) {
  // Convert input string to a number and store as a variable.
  var value = Number(num);
  // Split the input string into two arrays containing integers/decimals
  var res = num.split(".");
  // If there is no decimal point or only one decimal place found.
  if (res.length == 1 || res[1].length < 3) {
    // Set the number to two decimal places
    value = value.toFixed(1);
  }
  // Return updated or original number.
  return value;
}

export function getMiles(meters) {
  return meters * 0.000621371192;
}

export function getMeters(miles) {
  return miles * 1609.344;
}


export function checkUndefinedOrNull(value) {
  if (typeof value == "undefined" || value == null || value == '') {
    return '-';
  }
  return value;
}
